import React, {FC, useState} from "react"
import {Dropdown} from "@fluentui/react-northstar"
import {Occasion} from "../../types"
import {DropdownPlaceholder, FormLabel} from "./styles"
import occasionsTranslations from "../../utils/constants"

interface Props {
    occasions: Occasion[],
    onOccasionChange: (id: string) => void,
    disabled?: boolean
}

interface SelectOption {
    header: string,
    image: string,
    uuid: string
}

const CompanyCelebration: FC<Props> = ({occasions, onOccasionChange, disabled}) => {
    const [celebration, setCelebration] = useState(undefined)

    const handleCelebrationChange = (_: any, {value}: any) => {
        setCelebration(value)
        onOccasionChange(value.uuid)
    }

    return (
        <div>
            <FormLabel>
              Company Celebration
            </FormLabel>
            <Dropdown
                styles={{
                  padding: "0px",
                  margin: "3px 0px"
                }}
                fluid
                clearable
                // @ts-ignore
                placeholder={<DropdownPlaceholder>Select...</DropdownPlaceholder>}
                value={celebration}
                disabled={disabled}
                noResultsMessage="No match found"
                onChange={handleCelebrationChange}
                items={occasions.map((occasion) => {
                    return {
                        header: occasionsTranslations[occasion.name!]?.name ?? occasion.name,
                        image: occasionsTranslations[occasion.name!]?.icon ?? occasion.icon?.href,
                        uuid: occasion.uuid
                    } as SelectOption
                })}
            />
        </div>
    )
}

export default CompanyCelebration
